export const bottomMenu = [
  {
    name: "Home",
    href: "/"
  },
  {
    name: "Try Free",
    href: "https://app.imgforce.com/register"
  },
  {
    name: "API Documentation",
    href: "/api-documentation"
  },
  {
    name: "Login",
    href: "https://app.imgforce.com/register"
  }
];
